import React, { useState, useMemo, useEffect, useContext } from "react";
import "./index.scss";
import Formula3DPreview from "../../../FormulaGenerator/Formula3DPreview";
import topJawIcon from "./images/topJawIcon.png";
import bottomJawIcon from "./images/bottomJawIcon.png";
import { Link as IconLink, LinkOff as IconLinkOff } from "@mui/icons-material";
import BarInfo from "../../../mediaContent/barInfo";
import { StepContext } from "../../StepContext";
import { useTranslation } from "../../../i18n";

const OrthoBasicTreatment = ({
  stepId
}) => {
  const {
    _t,
    language
  } = useTranslation();
  const {
    dentalData,
    isPatient,
    setStepFormula,
    toggleBottomBarInfo,
    openVideoViewer
  } = useContext(StepContext);
  const elements = useMemo(() => {
    return [{
      id: "slideSapphireBraces",
      name: _t("Сапфировые брекеты"),
      img: require("./images/sapphire_br.png")
    }, {
      id: "slideSelfAlignBraces",
      name: _t("Самолигирующие брекеты"),
      img: require("./images/self_align_br.png")
    }, {
      id: "slideCeramicBraces",
      name: _t("Керамические брекеты"),
      img: require("./images/ceramic_br.png")
    }, {
      id: "slideCeramicSelfAlignBraces",
      name: _t("Керамические самолигирующие брекеты"),
      img: require("./images/ceramic_self_align_br.png")
    }, {
      id: "slideMetallBraces",
      name: _t("Металлические брекеты"),
      img: require("./images/metall_br.png")
    }, {
      id: "slideLingualBraces",
      name: _t("Лингвальные брекеты"),
      img: require("./images/lingual_br.png")
    }, {
      id: "slideMouthAligner",
      name: _t("Элайнеры"),
      img: require("./images/mouth_aligner.png")
    }, {
      id: "slideNoAlignSystem",
      name: _t("Без системы выравнивания"),
      img: require("./images/no_align_system.png")
    }];
  }, [_t]);

  function getSideKey(el, side) {
    return `${el}${side.charAt(0).toUpperCase() + side.slice(1)}`;
  }

  const [isSynced, setIsSynced] = useState(true);

  function toggleSync() {
    setIsSynced(prev => !prev);
  }

  const [currentType, setCurrentType] = useState({
    top: null,
    bottom: null
  });
  useEffect(() => {
    let dataForUpdate = {
      top: "slideNoAlignSystem",
      bottom: "slideNoAlignSystem"
    };

    if (dentalData?.slides?.length) {
      let topReg = /Top$/gm;
      let bottomReg = /Bottom$/gm;
      let top = null;
      let bottom = null;
      dentalData.slides.forEach(el => {
        if (topReg.test(el)) {
          top = el.replace(topReg, "");
        } else if (bottomReg.test(el)) {
          bottom = el.replace(bottomReg, "");
        }
      });
      dataForUpdate = {
        top: top,
        bottom: bottom
      };
    }

    setCurrentType(dataForUpdate);
    generateFormula(dataForUpdate);
  }, []); // const [slidesPack, setSlidesPack] = useState([]);

  function toggleCurrentType(id, side) {
    let dataForUpdate = { ...currentType
    };

    if (isSynced) {
      dataForUpdate = {
        top: id,
        bottom: id
      };
    } else {
      dataForUpdate = { ...dataForUpdate,
        [side]: id
      };
    }

    setCurrentType(dataForUpdate);
    generateFormula(dataForUpdate);
  }

  function generateFormula(dataForUpdate) {
    let items = [];

    if (dataForUpdate.top) {
      items.push(getSideKey(dataForUpdate.top, "top"));
    }

    if (dataForUpdate.bottom) {
      items.push(getSideKey(dataForUpdate.bottom, "bottom"));
    }

    setStepFormula(stepId, {
      prosthesis: [...items]
    });
  }

  const [isFormulaLoaded, setIsFormulaLoaded] = useState(false);

  function formulaLoadedCallback() {
    setIsFormulaLoaded(true);
  }

  const {
    topName,
    bottomName
  } = useMemo(() => {
    function getTypeName(type) {
      let el = elements.find(el => el.id === type);
      return el ? el.name : "";
    }

    return {
      topName: getTypeName(currentType.top),
      bottomName: getTypeName(currentType.bottom)
    };
  }, [currentType.bottom, currentType.top, elements]);

  function openBottomBar(key) {
    if (isPatient) {
      const selectedItem = BarInfo(language).find(el => el.type === key);

      if (selectedItem) {
        openVideoViewer(true, selectedItem.preview.video, selectedItem.title);
      }
    } else {
      toggleBottomBarInfo(true, key);
    }
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "orthoBasicTreatment"
  }, /*#__PURE__*/React.createElement("div", {
    className: "orthoBasicTreatment-controls top"
  }, /*#__PURE__*/React.createElement("img", {
    src: topJawIcon,
    className: "orthoBasicTreatment-controls-sideIcon",
    alt: ""
  }), /*#__PURE__*/React.createElement("div", {
    className: "orthoBasicTreatment-controls-optionList"
  }, elements.map(el => /*#__PURE__*/React.createElement("div", {
    key: el.id,
    className: `orthoBasicTreatment-controls-optionList-item ${currentType.top === el.id ? "active" : ""}`,
    onClick: () => {
      toggleCurrentType(el.id, "top");
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: el.img,
    alt: ""
  })))), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btnPrimary orthoBasicTreatment-controls-moreBtn",
    onClick: () => openBottomBar(currentType.top),
    disabled: currentType.top === "slideNoAlignSystem"
  }, _t("Подробней")), topName && /*#__PURE__*/React.createElement("div", {
    className: "orthoBasicTreatment-controls-about"
  }, `${_t("Верхняя челюсть:")} ${topName}`)), /*#__PURE__*/React.createElement("div", {
    className: "orthoBasicTreatment-controls bottom"
  }, /*#__PURE__*/React.createElement("img", {
    src: bottomJawIcon,
    className: "orthoBasicTreatment-controls-sideIcon",
    alt: ""
  }), /*#__PURE__*/React.createElement("div", {
    className: "orthoBasicTreatment-controls-optionList"
  }, elements.map(el => /*#__PURE__*/React.createElement("div", {
    key: el.id,
    className: `orthoBasicTreatment-controls-optionList-item ${currentType.bottom === el.id ? "active" : ""}`,
    onClick: () => {
      toggleCurrentType(el.id, "bottom");
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: el.img,
    alt: ""
  })))), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btnPrimary orthoBasicTreatment-controls-moreBtn",
    onClick: () => openBottomBar(currentType.bottom),
    disabled: currentType.bottom === "slideNoAlignSystem"
  }, _t("Подробней")), bottomName && /*#__PURE__*/React.createElement("div", {
    className: "orthoBasicTreatment-controls-about"
  }, `${_t("Нижняя челюсть:")} ${bottomName}`)), /*#__PURE__*/React.createElement("div", {
    className: `orthoBasicTreatment-syncBtn ${isSynced ? "active" : ""}`,
    onClick: toggleSync
  }, isSynced ? /*#__PURE__*/React.createElement(IconLink, {
    fontSize: "inherit"
  }) : /*#__PURE__*/React.createElement(IconLinkOff, {
    fontSize: "inherit"
  })), /*#__PURE__*/React.createElement("div", {
    className: "orthoBasicTreatment-container"
  }, /*#__PURE__*/React.createElement(Formula3DPreview, {
    stlPack: dentalData,
    availableSwitchers: ["top", "bottom", "base", "orthoSystems"],
    hideNotUsedSides: false,
    hideJawStateSwitcher: false,
    onLoaded: formulaLoadedCallback
  })));
};

export default OrthoBasicTreatment;